<script setup lang="ts">
import { User } from "lucide-vue-next";
import DialogProvider from "@/ui-plus/dialog/DialogProvider.vue";
import { Toaster } from "@/ui-plus/sonner";
import { RouterView } from "vue-router";
import { authState } from '@/ui-plus/useAuth';
import Button from '@/components/ui/button/Button.vue';
import { useColorMode } from "@vueuse/core";
import { computed } from "vue";
import { initiateRedirectLogin } from '@/ui-plus/auth/auth.pkce.redirect';

const mode = useColorMode();
const toasterTheme = computed(() => {
  if (mode.value === "auto") {
    return "system";
  } else {
    return mode.value;
  }
});
</script>

<template>

  <template v-if="authState.accessTokenPayload !== null">
    <RouterView />
  </template>
  <template v-else>
    <div class="flex flex-col items-center justify-center h-screen">
      <h1 class="text-2xl font-bold">Zemega.com Partner Dashboard</h1>
      <br>
      <Button class="mr-2"
              @click="initiateRedirectLogin('ask')">
        <User :stroke-width="3"
              class="h-8 w-8" /> Continue with MyOrderID
      </Button>
      <br>
      <div class="text-muted-foreground text-sm">
        To create your own partner website, you will need to<br>
        <ul style="list-style: disc; padding-left: 1.5em; text-align: left;">
          <li>Verify your email</li>
          <li>Verify your mobile phone number</li>
          <li>Verify your identity document</li>
          <li>Stripe supported country (business or individual)</li>
        </ul>
      </div>
      <br>
      <span class="font-bold text-sm text-center">
        No credit card needed.
        <br>
        Free for partners and sellers.
      </span>
    </div>
  </template>
  <DialogProvider />
  <Toaster :theme="toasterTheme"
           closeButton
           richColors
           class="pointer-events-auto" />
</template>
